import { render } from "./SecurityUpdatePolicy.vue?vue&type=template&id=5a1600b3&scoped=true&ts=true"
import script from "./SecurityUpdatePolicy.vue?vue&type=script&lang=ts"
export * from "./SecurityUpdatePolicy.vue?vue&type=script&lang=ts"

import "./SecurityUpdatePolicy.vue?vue&type=style&index=0&id=5a1600b3&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1600b3"]])

export default __exports__